import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES, SPEND_CATEGORY_TRANSLATIONS } from 'api/react-query/keys'
import { updateCategoryTranslations } from 'SpendControl/endpoints'
import type { PatchCategoryTranslations } from 'SpendControl/endpoints/spend-control'

type UpdateCategoryTranslationsParams = { id: string } & PatchCategoryTranslations

export const useUpdateCategoryTranslations = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCategoryTranslationsParams) => updateCategoryTranslations(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
      client.invalidateQueries({ queryKey: [SPEND_CATEGORY_TRANSLATIONS] })
    },
  })
}
